export enum AgreementCreateState {
  Authoring = "AUTHORING",
  InProcess = "IN_PROCESS"
}